export default "__VITE_ASSET__FfDx2tnq__"